<div [formGroup]="facilitySelectionGroup">
     
    <div class="form-group" [class.has-error]="facilityType.invalid || facility.invalid">
        <label class="control-label col-sm-3">{{label}}</label>
        <span class="col-sm-4">
            <select formControlName="facilityType" class="form-control">
                <option [ngValue]="null"></option>
                <option *ngFor="let option of facilityTypes" [ngValue]="option.id">{{ option.name }}</option>
            </select>
        </span>
        <span class="col-sm-4" *ngIf="facilityType.value && facilityType.value !== -1">
            <select formControlName="facility" class="form-control">
                <option [ngValue]="null"></option>
                <option *ngFor="let option of filteredFacilities" [ngValue]="option.id">{{ option.name }}</option>
            </select>
        </span>
    </div>
</div>


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/view-request/request-planning-modal/facility-selector/facility-selector.component.html